import { createRoot } from 'react-dom/client';
import { RouteComponentProps } from 'react-router-dom';
import SupplierControls from './supplier-controls';
import { createSettleTracker } from './settleTracker';

export type CaptureTarget = {
  organizationNumber: string;
  companyName?: string;
  hasSyna: boolean;
  hasCreditsafe: boolean;
  hasTic: boolean;
  history: RouteComponentProps['history'];
};

const CONTAINER_ID = 'supplier-controls-container';

// React commits the state a resolved request set a moment after the request itself resolved.
const afterCommit = () => new Promise<void>(resolve => setTimeout(resolve, 50));

/**
 * Renders the Control card for one supplier offscreen, waits until every provider has answered or
 * the ceiling passes, and returns the card's markup: the capture the contract flow takes from the
 * visible card when a contract is sent. Resolves to '' when nothing rendered.
 */
export const captureSupplierControls = async (target: CaptureTarget, { timeoutMs = 15000 } = {}): Promise<string> => {
  const host = document.createElement('div');
  host.setAttribute('aria-hidden', 'true');
  host.style.cssText = 'position:absolute;top:0;left:-10000px;width:480px;';
  document.body.appendChild(host);
  const root = createRoot(host);
  const tracker = createSettleTracker({ timeoutMs, idleMs: 1000 });
  try {
    root.render(
      <SupplierControls {...target} className="sup-details-controls-holder" onPendingChange={tracker.onPendingChange} />,
    );
    await tracker.settled;
    await afterCommit();
    return host.querySelector(`#${CONTAINER_ID}`)?.innerHTML ?? '';
  } finally {
    root.unmount();
    host.remove();
  }
};
